const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadpdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2100",
    "data-name": "Group 2100",
    transform: "translate(-1102 -169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_424",
    d: "M12 0A12 12 0 110 12 12 12 0 0112 0z",
    "data-name": "Path 424",
    transform: "translate(1102 169)",
    style: {
      fill: "#ccd8ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__iconmonstr-download-19",
    d: "M5.965 9.479L2.354 5.417h2.708V0h1.806v5.417h2.708zm4.062-.451v.9H1.9v-.9H1v1.806h9.93V9.028z",
    transform: "translate(1108.378 175.475)",
    style: {
      fill: "#5677b1"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadpdf);
export default __webpack_public_path__ + "static/media/downloadpdf.cbcd503991003e2ad7619de3865de215.svg";
export { ForwardRef as ReactComponent };